import { render } from "./UndetectedAreaEnus.vue?vue&type=template&id=4f1be3fc"
import script from "./UndetectedAreaEnus.vue?vue&type=script&lang=js"
export * from "./UndetectedAreaEnus.vue?vue&type=script&lang=js"

import "./UndetectedAreaEnus.vue?vue&type=style&index=0&id=4f1be3fc&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__